import { render, staticRenderFns } from "./legacy-login.vue?vue&type=template&id=df3692f8&"
import script from "./legacy-login.vue?vue&type=script&lang=js&"
export * from "./legacy-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "legacy-login.vue"
export default component.exports